(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["grabbr-review-center"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('grabbr-review-center')) {
  class GrabbrReviewCenter extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.abort = new AbortController();
      this.labels = JSON.parse(this.querySelector('[data-review-labels]').textContent);
      this.reviews = Array.from(this.querySelectorAll('[data-review]'));
      this.reviews.forEach((review, index) => review.dataset.originalIndex = index);
      this.media = Array.from(this.querySelectorAll('.grv-review [data-open-media]'));
      this.media.forEach((media, index) => media.dataset.mediaId = index);
      this.pageSize = Math.max(1, Number(this.dataset.pageSize) || 5);
      this.page = 1;
      this.rating = 5;
      this.withMedia = false;
      this.sort = 'recent';
      this.expandedGallery = false;
      document.addEventListener('click', event => {
        const link = event.target.closest?.('a[href="#grabbr-reviews"]');
        if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        event.stopPropagation();
        history.replaceState(null, '', '#grabbr-reviews');
        this.scrollIntoView({ block: 'start', behavior: 'instant' });
        const heading = this.querySelector('h2');
        heading?.setAttribute('tabindex', '-1');
        heading?.focus({ preventScroll: true });
      }, { capture: true, signal: this.abort.signal });
      this.listen(this, 'click', event => this.handleClick(event));
      this.listen(this, 'change', event => {
        if (event.target.matches('[data-sort]')) this.sort = event.target.value;
        else if (event.target.matches('[data-media-filter]')) this.withMedia = event.target.checked;
        else return;
        this.page = 1;
        this.render();
      });
      const dialog = this.querySelector('[data-lightbox]');
      this.listen(dialog, 'close', () => {
        dialog.querySelectorAll('video').forEach(video => video.pause());
        dialog.querySelector('[data-lightbox-content]').replaceChildren();
      });
      this.listen(dialog, 'click', event => { if (event.target === dialog) dialog.close(); });
      this.listen(document, 'shopify:block:select', event => {
        const group = event.detail?.blockId;
        const review = this.reviews.find(item => item.dataset.group === group);
        if (!review) return;
        this.rating = 0;
        this.withMedia = false;
        const mediaFilter = this.querySelector('[data-media-filter]');
        if (mediaFilter) mediaFilter.checked = false;
        this.page = Math.floor(this.filtered().indexOf(review) / this.pageSize) + 1;
        this.render();
        review.scrollIntoView({ block: 'center', behavior: 'instant' });
      });
      this.renderGallery();
      this.render();
      if (location.hash === '#' + this.querySelector('[data-review-form]').id || this.querySelector('.form__message,.errors,[data-form-success]')) this.toggleForm(true);
    }
    disconnectedCallback() { this.abort?.abort(); this.ready = false; }
    listen(target, name, callback) { target?.addEventListener(name, callback, { signal: this.abort.signal }); }
    filtered() {
      const list = this.reviews.filter(review => (!this.rating || Number(review.dataset.rating) === this.rating) && (!this.withMedia || review.querySelector('[data-open-media]')));
      return list.sort((a, b) => {
        const byIndex = Number(a.dataset.originalIndex) - Number(b.dataset.originalIndex);
        if (this.sort === 'highest') return Number(b.dataset.rating) - Number(a.dataset.rating) || byIndex;
        if (this.sort === 'lowest') return Number(a.dataset.rating) - Number(b.dataset.rating) || byIndex;
        return (Date.parse(b.dataset.date) || 0) - (Date.parse(a.dataset.date) || 0) || byIndex;
      });
    }
    render() {
      const list = this.filtered();
      const totalPages = Math.max(1, Math.ceil(list.length / this.pageSize));
      this.page = Math.min(totalPages, Math.max(1, this.page));
      this.reviews.forEach(review => review.hidden = true);
      const first = (this.page - 1) * this.pageSize;
      list.slice(first, first + this.pageSize).forEach(review => {
        review.hidden = false;
      });
      const listElement = this.querySelector('[data-review-list]');
      if (listElement) listElement.append(...list);
      this.querySelectorAll('[data-filter-rating]').forEach(button => button.setAttribute('aria-pressed', String(Number(button.dataset.filterRating) === this.rating)));
      const clear = this.querySelector('[data-clear]');
      if (clear) clear.hidden = !this.rating && !this.withMedia;
      const empty = this.querySelector('[data-no-results]');
      if (empty) empty.hidden = list.length > 0;
      const nav = this.querySelector('[data-pagination]');
      if (!nav) return;
      nav.replaceChildren();
      nav.hidden = list.length === 0;
      const pageLabel = this.labels.page.replace('__CURRENT__', this.page).replace('__TOTAL__', totalPages);
      nav.setAttribute('aria-label', pageLabel);
      this.querySelector('[data-page-status]').textContent = pageLabel;
      const add = (text, label, page, disabled = false, current = false) => {
        const button = document.createElement('button');
        button.type = 'button';
        const paths = {
          '«': 'M18 6l-6 6 6 6M6 5v14',
          '‹': 'M15 6l-6 6 6 6',
          '›': 'M9 6l6 6-6 6',
          '»': 'M6 6l6 6-6 6M18 5v14'
        };
        if (paths[text]) {
          button.className = 'grv-page-arrow';
          const icon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
          icon.setAttribute('viewBox', '0 0 24 24');
          icon.setAttribute('aria-hidden', 'true');
          icon.setAttribute('focusable', 'false');
          const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
          path.setAttribute('d', paths[text]);
          icon.append(path);
          button.append(icon);
        } else button.textContent = text;
        button.setAttribute('aria-label', label);
        button.dataset.page = page;
        button.disabled = disabled;
        if (current) button.setAttribute('aria-current', 'page');
        nav.append(button);
      };
      const rtl = getComputedStyle(this).direction === 'rtl';
      add(rtl ? '»' : '«', this.labels.first, 1, this.page === 1);
      add(rtl ? '›' : '‹', this.labels.previous, this.page - 1, this.page === 1);
      const firstPage = Math.max(1, Math.min(this.page - 1, totalPages - 2));
      const pages = Array.from({ length: Math.min(3, totalPages) }, (_, index) => firstPage + index);
      pages.forEach(page => {
        add(String(page), this.labels.page.replace('__CURRENT__', page).replace('__TOTAL__', totalPages), page, false, page === this.page);
      });
      add(rtl ? '‹' : '›', this.labels.next, this.page + 1, this.page === totalPages);
      add(rtl ? '«' : '»', this.labels.last, totalPages, this.page === totalPages);
    }
    renderGallery() {
      const container = this.querySelector('[data-gallery]');
      const section = this.querySelector('[data-gallery-section]');
      section.hidden = this.media.length === 0;
      container.replaceChildren();
      const visible = this.expandedGallery ? this.media : this.media.slice(0, 7);
      visible.forEach(button => container.append(button.cloneNode(true)));
      if (this.media.length > 7) {
        const button = document.createElement('button');
        button.type = 'button'; button.className = 'grv-gallery-more'; button.dataset.galleryMore = '';
        button.textContent = this.expandedGallery ? this.labels.less : this.labels.more;
        button.setAttribute('aria-expanded', String(this.expandedGallery));
        container.append(button);
      }
    }
    toggleForm(force) {
      const form = this.querySelector('[data-review-form]');
      form.hidden = force === undefined ? !form.hidden : !force;
      this.querySelector('[data-toggle-form]').setAttribute('aria-expanded', String(!form.hidden));
      if (!form.hidden) form.querySelector('input:not([type=hidden])')?.focus({ preventScroll: true });
    }
    handleClick(event) {
      const target = event.target.closest('button,a');
      if (!target || !this.contains(target)) return;
      if (target.hasAttribute('data-filter-rating')) {
        const rating = Number(target.dataset.filterRating); this.rating = this.rating === rating ? 0 : rating; this.page = 1; this.render();
      } else if (target.hasAttribute('data-clear')) {
        this.rating = 0; this.withMedia = false; this.page = 1; this.querySelector('[data-media-filter]').checked = false; this.render();
      } else if (target.hasAttribute('data-page')) {
        this.page = Number(target.dataset.page); this.render(); this.querySelector('.grv-toolbar')?.scrollIntoView({ block: 'start', behavior: 'instant' }); this.querySelector('[data-pagination] [aria-current=page]')?.focus({ preventScroll: true });
      } else if (target.hasAttribute('data-gallery-more')) {
        this.expandedGallery = !this.expandedGallery; this.renderGallery();
      } else if (target.hasAttribute('data-open-media')) {
        const original = this.media[Number(target.dataset.mediaId)];
        const dialog = this.querySelector('[data-lightbox]');
        if (original) { dialog.querySelector('[data-lightbox-content]').replaceChildren(original.querySelector('template').content.cloneNode(true)); dialog.showModal(); }
      } else if (target.hasAttribute('data-close-media')) {
        this.querySelector('[data-lightbox]').close();
      } else if (target.hasAttribute('data-toggle-form')) {
        event.preventDefault(); this.toggleForm();
      }
    }
  }
  customElements.define('grabbr-review-center', GrabbrReviewCenter);
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
